module.exports = __webpack_public_path__ + "img/wrench.71bf47a4.svg";